import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgIf} from '@angular/common';

@Component({
    selector: 'app-warning-message',
    imports: [NgIf],
    templateUrl: './warning-message.component.html',
    styleUrl: './warning-message.component.scss'
})
export class WarningMessageComponent {
  @Input() title: string = 'Warning'
  @Input() message: string
  @Input() type: 'warning' | 'error' | 'success' = 'warning'
  /** Shows a cross that emits `dismiss`; removing the message is up to the parent. */
  @Input() dismissible = false
  @Output() dismiss = new EventEmitter<void>()
}
